const initialState = {
    isModalVisible: false,
  };
  
  const suspisiousModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_SUSPISIOUS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_SUSPISIOUS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default suspisiousModalReducer;
  